import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export default function usePrintAddress() {
  const { enqueueSnackbar } = useSnackbar();

  const [getLoading, setGetLoading] = useState(false);
  const [data, setData] = useState();

  const getPrintData = guid => {
    setGetLoading(true);
    axiosClient
      .get(`/InventoryAddress/Print?guid=${guid}`)
      .then(res => {
        if (res.status === 200) {
          const value = res.data.value;
          setData(value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => {
        setGetLoading(false);
      });
  };

  return [getLoading, data, setData, getPrintData];
}
